/* globals bd */

define(function (require, exports) {
    'use strict';

    // @ngInject
    exports.metroToggle = function () {

        // @ngInject
        /**
         * @param {ng.IHttpService} $http
         * @param {ng.ILogService} $log
         * @param {ng.IQService} $q
         */
        this.$get = function ($http,lpCoreUtils,$q,metToggle) {

            function setAllToggles(data) {
                sessionStorage.setItem('Toggle', data);
            }
            function getStoredToggles(){
                return sessionStorage.getItem('Toggle');
            }
            function getRequiredToggle(list,requiredToggle){
                var toggleList = new Array();
                list = list.replace('{','');
                list= list.replace('}','');
                toggleList = list.split(",");
                var value ={};
                var val='false';
                for (var i = 0; i < toggleList.length; i++) {
                        value = toggleList[i].split(":");
                    if(value[0]=='\"'+requiredToggle+'\"'){
                        val=value[1];
                    }
                }
               return val
            }
            function getAllToggles(){
                var deferred = $q.defer();
                metToggle.api().getToggle().then(function(response) {
                    deferred.resolve(response);
                   })
                   .catch(function(error) {
                       console.log('error');
                       deferred.reject(response);
                   })
                   return deferred.promise;
            }
            
            return {
                setAllToggles: setAllToggles,  
                getStoredToggles:getStoredToggles,
                getAllToggles:getAllToggles,
                getRequiredToggle:getRequiredToggle             
            };
        };

    };


});



// WEBPACK FOOTER //
// ./scripts/services/metroToggleService.js